(function () {
  const MINIMUM_EUR = 30;
  const MINIMUM_USD = 35;

  const WARNING_MSG_EUR = "Minimum order value is €" + MINIMUM_EUR + ". Please add more items to your cart.";
  const WARNING_MSG_USD = "Minimum order value is $" + MINIMUM_USD + ". Please add more items to your cart.";

  function getCurrency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active : 'EUR';
  }

  function getMinimum() {
    return getCurrency() === 'USD' ? MINIMUM_USD : MINIMUM_EUR;
  }

  function getWarningMsg() {
    return getCurrency() === 'USD' ? WARNING_MSG_USD : WARNING_MSG_EUR;
  }

  function injectWarning() {
    if (document.getElementById('oj-minimum-warning')) return;
    const warning = document.createElement('div');
    warning.id = 'oj-minimum-warning';
    warning.style.cssText = [
      'display:none',
      'background:#FF3939',
      'color:#fff',
      'padding:1rem 1.2rem',
      'font-family:Inter,sans-serif',
      'font-size:1.4rem',
      'font-weight:600',
      'margin-bottom:1rem',
      'text-align:center'
    ].join(';');
    const ref = document.querySelector('[name="checkout"], .cart__checkout-button, #checkout');
    if (ref) ref.parentNode.insertBefore(warning, ref);
  }

  function injectOverlay() {
    if (document.getElementById('oj-payment-overlay')) return;
    const overlay = document.createElement('div');
    overlay.id = 'oj-payment-overlay';
    overlay.style.cssText = [
      'display:none',
      'position:absolute',
      'inset:0',
      'background:rgba(255,255,255,0.65)',
      'z-index:9999',
      'cursor:not-allowed'
    ].join(';');
    const paymentContainer = document.querySelector(
      '.shopify-payment-button, [data-shopify="payment-button"], .cart__dynamic-checkout-buttons, shopify-accelerated-checkout'
    );
    if (paymentContainer) {
      if (window.getComputedStyle(paymentContainer).position === 'static')
        paymentContainer.style.position = 'relative';
      paymentContainer.appendChild(overlay);
    }
  }

  function applyBlock(block) {
    // Standard checkout button
    document.querySelectorAll('[name="checkout"], .cart__checkout-button, #checkout').forEach(btn => {
      btn.disabled = block;
      btn.style.opacity = block ? '0.4' : '1';
      btn.style.pointerEvents = block ? 'none' : '';
      btn.style.cursor = block ? 'not-allowed' : '';
    });

    // Payment overlay
    const overlay = document.getElementById('oj-payment-overlay');
    if (overlay) overlay.style.display = block ? 'block' : 'none';

    // Accelerated checkout buttons
    document.querySelectorAll(
      'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button__button'
    ).forEach(el => {
      el.style.pointerEvents = block ? 'none' : '';
      el.style.opacity = block ? '0.4' : '1';
    });

    // Warning message
    const warning = document.getElementById('oj-minimum-warning');
    if (warning) {
      warning.style.display = block ? 'block' : 'none';
      if (block) warning.textContent = getWarningMsg();
    }
  }

  // === CORE: fetch cart and apply block ===
  let lastTotal = null;

  function checkCart() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price / 100;

        injectWarning();
        injectOverlay();

        const shouldBlock = total < getMinimum();
        applyBlock(shouldBlock);
        lastTotal = total;
      })
      .catch(() => {});
  }

  // === INTERCEPT form submit as extra safety net ===
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.action.indexOf('/checkout') === -1) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price / 100;
        if (total >= getMinimum()) {
          // Allow – remove listener temporarily and resubmit
          form.removeEventListener('submit', arguments.callee);
          form.submit();
        } else {
          applyBlock(true);
        }
      });
  }, true);

  // === START: check immediately + poll every 500ms ===
  document.addEventListener('DOMContentLoaded', function () {
    checkCart();
    setInterval(checkCart, 500);
  });

})();